module.exports = __webpack_public_path__ + "static/media/guanggaoen.e4ca675b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/guanggaoen.png
// module id = 294
// module chunks = 0